import React, { useState } from 'react';
import { Box } from '@material-ui/core';
import { useTranslate } from 'react-admin';
import CustomPoper from '../CustomizedUIs/CustomPoperCalendar';
import OneLineTextField from '../users/CustomTextField';
import { useSelector, useDispatch } from 'react-redux';
import { changeNodeGlobalData } from '../redux/actions/tree-action';

function ServiceCall() {
    const translate = useTranslate();
    const dispatch = useDispatch();

    const [openPoper, setOpenPopper] = useState(false);
    const { isEditing, nodeSelected } = useSelector(state => state.tree);
    const { ipAddress } = nodeSelected.applicationData.nodeApplication.serviceCall;

    const textOnChange = (event) => {
        const newNode = {
            ...nodeSelected.applicationData,
            nodeApplication: {
                ...nodeSelected.applicationData.nodeApplication,
                serviceCall: {
                    ipAddress: event.target.value
                }
            }
        };
        dispatch(changeNodeGlobalData(newNode));
    }

    return (
        <Box>
            <Box mt={3.5}>
                <OneLineTextField
                    disabled={!isEditing}
                    id="filled-basic"
                    label={translate('resources.infoPage.serviceCall.ipAddress')}
                    value={ipAddress}
                    onChange={textOnChange}
                    style={{ width: 500 }}
                    endDom={<CustomPoper
                        color={'#e5f1f8'}
                        fontSize={'11px'}
                        open={openPoper}
                        handleClick={() => setOpenPopper(true)}
                        handleClose={() => setOpenPopper(false)}
                        title={translate('resources.infoPage.serviceCall.ipAddressLabel')}
                        content={translate('resources.infoPage.serviceCall.ipAddressContent')}
                        icon={<b>?</b>}
                    />}
                />
            </Box>
        </Box>
    )
}

export default ServiceCall;
